"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StartAdornmentSplit = exports.LeftPanelRoot = exports.ConfirmButtonWrapper = void 0;
var _mui = require("@ori-ui/mui");
const LeftPanelRoot = exports.LeftPanelRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  width: '100%',
  zIndex: 1,
  [theme.breakpoints.up('md')]: {
    boxShadow: _mui.SHADOW_LEVEL2,
    height: '100%',
    maxWidth: 450,
    minWidth: 420,
    paddingTop: theme.spacing(4)
  }
}));
const StartAdornmentSplit = exports.StartAdornmentSplit = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderLeft: `1px solid ${theme.palette.default.light}`,
  height: 20,
  margin: theme.spacing(0, 1)
}));
const ConfirmButtonWrapper = exports.ConfirmButtonWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxShadow: _mui.SHADOW_LEVEL4,
  padding: theme.spacing(3),
  textAlign: 'center'
}));